import type { SupabaseClient } from '@supabase/supabase-js';
import { supabase, isSupabaseConfigured } from '@/config/supabase';

// Delegates to the single Supabase client singleton in `@/config/supabase`
// instead of creating a second, independently-initializing client. Two
// clients meant two separate async session-restore lifecycles racing
// against each other, which caused data queries to fire before auth was
// ready and silently come back empty (RLS-filtered) on fresh page loads.
export function getSupabaseClient(): SupabaseClient {
  if (!isSupabaseConfigured()) {
    throw new Error(
      'Supabase credentials not configured. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file.'
    );
  }
  return supabase;
}

// Helper to get current user
export async function getCurrentUser() {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
}

// Helper to get current session
export async function getCurrentSession() {
  const { data: { session } } = await supabase.auth.getSession();
  return session;
}
